// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrandIcon_wrapper__3bRY0"};